import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { objectToQuery } from 'helpers/Formatter';
import { showSuccess, showFailure } from 'actions/notificationActions';
import { generateOAuthUserToken } from 'actions/companyDetailsActions';
import { getTranslatedString } from 'helpers/i18n';

import Google from './Google';
import Azure from './Azure';

class CalendarIntegrations extends React.Component {
  UNSAFE_componentWillMount() {
    const params = browserHistory.getCurrentLocation().query;
    if (!params.calendar_connected) return;

    if (params.calendar_connected === 'true') {
      this.props.showSuccess('successfullyConnectedCalendar');
    } else if (params.calendar_connected === 'false') {
      this.props.showFailure('couldNotConnectToCalendar');
    }

    browserHistory.push(browserHistory.getCurrentLocation().pathname);
  }

  redirectToOAuth = config => async () => {
    const response = await this.props.generateOAuthUserToken();
    if (!response.value) return;

    const { oauth_route, ...params } = config;
    const url = oauth_route + objectToQuery({ ...params, state: response.value.token });

    window.location.assign(url);
  };

  render() {
    return (
      <div className="row" style={{ margin: '25px 0px' }}>
        <div>
          <p>{getTranslatedString('landlordPortal.CalendarIntegrations.description')}</p>

          <div className="row" style={{ display: 'flex' }}>
            <div className="col-xs-6" style={{ alignSelf: 'flex-end' }}>
              <Google redirectToOAuth={this.redirectToOAuth} />
            </div>

            <div className="col-xs-6" style={{ alignSelf: 'flex-end' }}>
              <Azure redirectToOAuth={this.redirectToOAuth} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  showSuccess,
  showFailure,
  generateOAuthUserToken,
})(CalendarIntegrations);
